export function addInitialConditions(filter: any) {
  if (!filter) {
    return filter;
  }

  const audiences = [...(filter.conditions?.[0]?.conditions || [])];
  const conditions = [...(filter.conditions?.[1]?.conditions || [])];

  if (audiences.length === 0) {
    audiences.push({
      type: "base",
      attributeType: "AUDIENCE",
      attributeName: "Audience",
      criteria: "IN",
      value: {
        type: "string[]",
      },
    });
  }

  if (conditions.length === 0) {
    conditions.push({
      type: "combined",
      conditionType: "AND",
      conditions: [
        {
          type: "base",
        },
      ],
    });
  }

  return {
    type: "combined",
    conditionType: "AND",
    conditions: [
      {
        type: "combined",
        conditionType: "AND",
        conditions: audiences,
      },
      {
        type: "combined",
        conditionType: "OR",
        conditions: conditions,
      },
    ],
  };
}

export { removeEmptyConditions } from "../../utils/segmentConditionUtils";
